module.exports = __webpack_public_path__ + "static/media/play.142f8462.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/play.svg
// module id = 549
// module chunks = 0